<template>
  <!-- [sc-48351] I campi che cambiano con la categoria dell'articolo, comuni
       alla creazione da Listini e alla modale del preventivo: prima erano
       scritti due volte e la modale era rimasta indietro.

       Riempie l'oggetto `form` del genitore, come farebbe un fieldset dentro
       il suo modulo: per questo i v-model scrivono sulla prop. -->
  <!-- eslint-disable vue/no-mutating-props -->
  <!-- ── Gruppo AREA ── -->
  <template v-if="categoryGroup === 'area'">
    <!-- Piastrelle: selezione tipologia + campi variabili -->
    <template v-if="category === 'piastrelle'">
      <!-- La modale del preventivo chiede la tipologia in un passo suo,
             prima del modulo: qui non va ripetuta. -->
      <div v-if="chiediTipologia" class="create-item-row">
        <div class="field" data-tour="item-typology">
          <label>Tipologia *</label>
          <StatusSelect
            v-model="form.subCategory"
            :options="subCategoryOptions"
            placeholder="Seleziona tipologia..."
            placeholderIcon="fa-tag"
          />
        </div>
      </div>

      <UnitaTipologiaAvviso
        :category="category"
        :sub-category="form.subCategory"
        :sales-unit="form.salesUnit"
        :opzioni="salesUnitOptions"
        @usa="form.salesUnit = $event"
      />

      <!-- Elementi Lineari (ML) -->
      <template v-if="tileGroup === 'linear'">
        <div class="create-item-row">
          <div class="field">
            <label for="formatLabel">Formato</label>
            <input
              id="formatLabel"
              type="text"
              v-model="form.formatLabel"
              placeholder="es. 60x120"
            />
          </div>
          <div class="field">
            <label for="thicknessMm">Spessore (mm)</label>
            <input
              id="thicknessMm"
              type="number"
              step="any"
              min="0"
              v-model.number="form.thicknessMm"
              placeholder="es. 10"
            />
          </div>
          <div class="field">
            <label for="finish">Finitura</label>
            <input
              id="finish"
              type="text"
              v-model="form.finish"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="mlPerBox">ML / scatola</label>
            <input
              id="mlPerBox"
              type="number"
              step="any"
              min="0"
              v-model.number="form.mlPerBox"
              placeholder="es. 2.5"
            />
          </div>
        </div>
      </template>

      <!-- Decori / Fondi (M2) -->
      <template v-else-if="tileGroup === 'area'">
        <div class="create-item-row">
          <div class="field">
            <label for="formatLabel">Formato</label>
            <input
              id="formatLabel"
              type="text"
              v-model="form.formatLabel"
              placeholder="es. 60x120"
            />
          </div>
          <div class="field">
            <label for="widthCm">Larghezza (cm)</label>
            <input
              id="widthCm"
              type="number"
              step="any"
              min="0"
              v-model.number="form.widthCm"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="heightCm">Altezza (cm)</label>
            <input
              id="heightCm"
              type="number"
              step="any"
              min="0"
              v-model.number="form.heightCm"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="thicknessMm">Spessore (mm)</label>
            <input
              id="thicknessMm"
              type="number"
              step="any"
              min="0"
              v-model.number="form.thicknessMm"
              placeholder="es. 10"
            />
          </div>
          <div class="field">
            <label for="finish">Finitura</label>
            <input
              id="finish"
              type="text"
              v-model="form.finish"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="sqmPerBox">M² / scatola</label>
            <input
              id="sqmPerBox"
              type="number"
              step="any"
              min="0"
              v-model.number="form.sqmPerBox"
              placeholder="es. 1.44"
            />
          </div>
        </div>
      </template>

      <!-- Battiscopa / Listelli / Gradini / Scalini / Altri Pezzi Speciali (PZ) -->
      <template v-else-if="tileGroup === 'piece'">
        <div class="create-item-row">
          <div class="field">
            <label for="formatLabel">Formato</label>
            <input
              id="formatLabel"
              type="text"
              v-model="form.formatLabel"
              placeholder="es. 60x120"
            />
          </div>
          <div class="field">
            <label for="thicknessMm">Spessore (mm)</label>
            <input
              id="thicknessMm"
              type="number"
              step="any"
              min="0"
              v-model.number="form.thicknessMm"
              placeholder="es. 10"
            />
          </div>
          <div class="field">
            <label for="finish">Finitura</label>
            <input
              id="finish"
              type="text"
              v-model="form.finish"
              placeholder="inserisci"
            />
          </div>
          <div class="field">
            <label for="sqmPerBox">M² / scatola</label>
            <input
              id="sqmPerBox"
              type="number"
              step="any"
              min="0"
              v-model.number="form.sqmPerBox"
              placeholder="es. 1.44"
            />
          </div>
        </div>
      </template>

      <!-- Pz/scatola comune a tutti i tileGroup (la giacenza si
             gestisce dal magazzino, non dalla scheda articolo) -->
      <template v-if="tileGroup">
        <div class="create-item-row">
          <div class="field">
            <label for="piecesPerBox">Pz / scatola</label>
            <input
              id="piecesPerBox"
              type="number"
              min="0"
              v-model.number="form.piecesPerBox"
              placeholder="inserisci"
            />
          </div>
        </div>
        <div class="create-item-row">
          <!-- Stesso nome dell'altra ancora del prezzo: le due schede
                 non sono mai in pagina insieme. -->
          <div class="field" data-tour="item-price">
            <label for="price">{{ priceLabel }} — IVA esclusa</label>
            <input
              id="price"
              type="number"
              step="any"
              min="0"
              v-model.number="form.price"
              placeholder="inserisci"
            />
          </div>
        </div>
      </template>
    </template>

    <!-- Parquet -->
    <template v-else-if="category === 'parquet'">
      <div class="create-item-row">
        <div class="field">
          <label for="material">Materiale (specie legnosa)</label>
          <StatusSelect
            v-model="form.material"
            :options="parquetMaterialOptions"
            placeholder="Seleziona specie..."
            placeholderIcon="fa-tree"
          />
        </div>
        <div class="field">
          <label for="finish">Finitura (lavorazione)</label>
          <input
            id="finish"
            type="text"
            v-model="form.finish"
            placeholder="es. Spazzolato naturale"
          />
        </div>
        <div class="field">
          <label for="scelta">Scelta</label>
          <StatusSelect
            v-model="form.specs.scelta"
            :options="parquetSceltaOptions"
            placeholder="Seleziona scelta..."
            placeholderIcon="fa-shapes"
          />
        </div>
      </div>
      <div class="create-item-row">
        <div class="field">
          <label for="formatLabel">Formato</label>
          <input
            id="formatLabel"
            type="text"
            v-model="form.formatLabel"
            placeholder="es. 65-70x440-490 mm"
          />
        </div>
        <div class="field">
          <label for="thicknessMm">Spessore (mm)</label>
          <input
            id="thicknessMm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.thicknessMm"
            placeholder="es. 10"
          />
        </div>
        <div class="field">
          <label for="widthCm">Larghezza (cm)</label>
          <input
            id="widthCm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.widthCm"
            placeholder="es. 6.5"
          />
        </div>
        <div class="field">
          <label for="lengthMm">Lunghezza (mm)</label>
          <input
            id="lengthMm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.lengthMm"
            placeholder="es. 440"
          />
        </div>
      </div>
      <!-- Dati imballo: senza M²/scatola l'articolo non è preventivabile
             (la quantità in mq non è convertibile in scatole) -->
      <div class="create-item-row">
        <div class="field">
          <label for="sqmPerBox">M² / scatola</label>
          <input
            id="sqmPerBox"
            type="number"
            step="any"
            min="0"
            v-model.number="form.sqmPerBox"
            placeholder="es. 2.13"
          />
        </div>
        <div class="field">
          <label for="piecesPerBox">Pz / scatola</label>
          <input
            id="piecesPerBox"
            type="number"
            min="0"
            v-model.number="form.piecesPerBox"
            placeholder="inserisci"
          />
        </div>
      </div>
    </template>

    <!-- Altre categorie area (rivestimenti parete, ecc.) -->
    <template v-else>
      <div class="create-item-row">
        <div class="field">
          <label for="formatLabel">Formato (es. 60x120)</label>
          <input
            id="formatLabel"
            type="text"
            v-model="form.formatLabel"
            placeholder="es. 60x120"
          />
        </div>
        <div class="field">
          <label for="widthCm">Larghezza (cm)</label>
          <input
            id="widthCm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.widthCm"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="heightCm">Altezza (cm)</label>
          <input
            id="heightCm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.heightCm"
            placeholder="inserisci"
          />
        </div>
        <div class="field">
          <label for="thicknessMm">Spessore (mm)</label>
          <input
            id="thicknessMm"
            type="number"
            step="any"
            min="0"
            v-model.number="form.thicknessMm"
            placeholder="es. 10"
          />
        </div>
        <div class="field">
          <label for="surface">Superficie</label>
          <input
            id="surface"
            type="text"
            v-model="form.surface"
            placeholder="es. Matt, Lucido"
          />
        </div>
        <div class="field">
          <label for="color">Colore</label>
          <input
            id="color"
            type="text"
            v-model="form.color"
            placeholder="inserisci"
          />
        </div>
      </div>
      <div class="create-item-row">
        <div class="field">
          <label for="sqmPerBox">M² / scatola</label>
          <input
            id="sqmPerBox"
            type="number"
            step="any"
            min="0"
            v-model.number="form.sqmPerBox"
            placeholder="es. 1.44"
          />
        </div>
        <div class="field">
          <label for="piecesPerBox">Pz / scatola</label>
          <input
            id="piecesPerBox"
            type="number"
            min="0"
            v-model.number="form.piecesPerBox"
            placeholder="inserisci"
          />
        </div>
      </div>
    </template>
  </template>

  <!-- ── Gruppo PIECE ── -->
  <template v-if="categoryGroup === 'piece'">
    <div class="create-item-row">
      <div v-if="category === 'sanitari'" class="field">
        <label for="fixtureType">Tipo</label>
        <StatusSelect
          v-model="form.fixtureType"
          :options="fixtureTypeOptions"
        />
      </div>
      <div v-if="category === 'sanitari'" class="field">
        <label for="fixturePosition">Posizione</label>
        <StatusSelect
          v-model="form.fixturePosition"
          :options="fixturePositionOptions"
        />
      </div>
      <div class="field">
        <label for="finish">Finitura</label>
        <input
          id="finish"
          type="text"
          v-model="form.finish"
          placeholder="es. Cromo, Nero opaco"
        />
      </div>
      <div class="field">
        <label for="color">Colore</label>
        <input
          id="color"
          type="text"
          v-model="form.color"
          placeholder="inserisci"
        />
      </div>
    </div>
  </template>

  <!-- ── Gruppo LINEAR ── -->
  <template v-if="categoryGroup === 'linear'">
    <div class="create-item-row">
      <div class="field">
        <label for="material">Materiale</label>
        <input
          id="material"
          type="text"
          v-model="form.material"
          placeholder="es. Alluminio, Inox"
        />
      </div>
      <div class="field">
        <label for="lengthMm">Lunghezza (mm)</label>
        <input
          id="lengthMm"
          type="number"
          step="any"
          min="0"
          v-model.number="form.lengthMm"
          placeholder="es. 2500"
        />
      </div>
      <div class="field">
        <label for="mlPerBox">ML / confezione</label>
        <input
          id="mlPerBox"
          type="number"
          step="any"
          min="0"
          v-model.number="form.mlPerBox"
          placeholder="es. 2.5"
        />
      </div>
    </div>
  </template>

  <!-- ── Gruppo FURNITURE ── -->
  <template v-if="categoryGroup === 'furniture'">
    <div class="create-item-row">
      <div class="field">
        <label for="widthCm">Larghezza (cm)</label>
        <input
          id="widthCm"
          type="number"
          step="any"
          min="0"
          v-model.number="form.widthCm"
          placeholder="inserisci"
        />
      </div>
      <div class="field">
        <label for="heightCm">Altezza (cm)</label>
        <input
          id="heightCm"
          type="number"
          step="any"
          min="0"
          v-model.number="form.heightCm"
          placeholder="inserisci"
        />
      </div>
      <div class="field">
        <label for="material">Materiale</label>
        <input
          id="material"
          type="text"
          v-model="form.material"
          placeholder="es. MDF, Rovere"
        />
      </div>
      <div class="field">
        <label for="finish">Finitura</label>
        <input
          id="finish"
          type="text"
          v-model="form.finish"
          placeholder="es. Bianco opaco"
        />
      </div>
    </div>
  </template>

  <!-- ── Gruppo BATH (bagno) ── -->
  <template v-if="categoryGroup === 'bath'">
    <div class="create-item-row">
      <div class="field">
        <label>Tipologia</label>
        <input type="text" :value="form.subCategory" readonly placeholder="—" />
      </div>
    </div>
  </template>

  <!-- ── Dati per scatola non coperti dal blocco della categoria ──
         [sc-48538 / task 48562] Stesso rimedio di EditItemPage: se l'articolo
         si vende a misura questi campi servono comunque, anche quando la sua
         categoria non è fra quelle che li mostrano. Senza, l'articolo nasce
         incompleto e il preventivo che lo contiene non è confermabile finché
         non si passa dalla modifica. -->
  <template v-if="extraBoxFields.length">
    <div class="create-item-row">
      <div v-if="extraBoxFields.includes('sqmPerBox')" class="field">
        <label for="extraSqmPerBox">M² / scatola</label>
        <input
          id="extraSqmPerBox"
          type="number"
          step="any"
          min="0"
          v-model.number="form.sqmPerBox"
          placeholder="es. 1.44"
        />
      </div>
      <div v-if="extraBoxFields.includes('mlPerBox')" class="field">
        <label for="extraMlPerBox">ML / confezione</label>
        <input
          id="extraMlPerBox"
          type="number"
          step="any"
          min="0"
          v-model.number="form.mlPerBox"
          placeholder="es. 2.4"
        />
      </div>
      <div v-if="extraBoxFields.includes('piecesPerBox')" class="field">
        <label for="extraPiecesPerBox">Pz / scatola</label>
        <input
          id="extraPiecesPerBox"
          type="number"
          min="0"
          v-model.number="form.piecesPerBox"
          placeholder="es. 6"
        />
      </div>
    </div>
  </template>

  <!-- ── Gruppo GENERIC ── -->
  <template v-if="categoryGroup === 'generic'">
    <div class="create-item-row">
      <div class="field">
        <label for="notes">Note</label>
        <textarea
          id="notes"
          v-model="form.notes"
          placeholder="inserisci"
          rows="3"
        />
      </div>
    </div>
  </template>
</template>

<script>
import StatusSelect from "@/components/StatusSelect.vue";
import UnitaTipologiaAvviso from "@/components/UnitaTipologiaAvviso.vue";
import { salesUnitsFor } from "@/config/catalog";
import { boxFieldsForItem } from "@/utilities/itemStockData";
import {
  TILE_SUBCATEGORIES,
  boxFieldsFromCategory,
  getCategoryGroup,
  priceLabelFor,
  tileGroupOf,
} from "@/config/itemFields";

export default {
  name: "ItemCategoryFields",
  components: { StatusSelect, UnitaTipologiaAvviso },
  props: {
    // Il modulo del genitore: i campi scrivono direttamente qui.
    form: { type: Object, required: true },
    // Valore di `items.category`.
    category: { type: String, default: "" },
    // La tendina della tipologia delle piastrelle.
    chiediTipologia: { type: Boolean, default: true },
  },
  data() {
    return {
      fixtureTypeOptions: [
        { value: "", label: "— scegli —" },
        { value: "vaso", label: "Vaso", icon: "fa-toilet" },
        { value: "bidet", label: "Bidet", icon: "fa-water" },
        { value: "lavabo", label: "Lavabo", icon: "fa-droplet" },
        { value: "box doccia", label: "Box doccia", icon: "fa-shower" },
        { value: "piatto doccia", label: "Piatto doccia", icon: "fa-grip" },
        { value: "vasca", label: "Vasca", icon: "fa-bath" },
        {
          value: "mobile bagno",
          label: "Mobile bagno",
          icon: "fa-layer-group",
        },
        { value: "specchiera", label: "Specchiera", icon: "fa-image" },
        { value: "rubinetteria", label: "Rubinetteria", icon: "fa-faucet" },
        { value: "idraulica", label: "Idraulica", icon: "fa-wrench" },
        { value: "altro", label: "Altro", icon: "fa-circle-question" },
      ],
      subCategoryOptions: TILE_SUBCATEGORIES.map((voce) => ({
        value: voce,
        label: voce,
      })),
      fixturePositionOptions: [
        { value: "", label: "— scegli —" },
        { value: "sospeso", label: "Sospeso", icon: "fa-arrow-up" },
        { value: "terra", label: "A terra", icon: "fa-arrow-down" },
        { value: "mono-blocco", label: "Mono-blocco", icon: "fa-cube" },
        { value: "nessuno", label: "Nessuno", icon: "fa-ban" },
        { value: "altro", label: "Altro", icon: "fa-circle-question" },
      ],
      parquetMaterialOptions: [
        { value: "", label: "— nessuna —" },
        { value: "ROVERE", label: "Rovere" },
        { value: "TEAK", label: "Teak" },
        { value: "IROKO", label: "Iroko" },
        { value: "DOUSSIE", label: "Doussié" },
      ],
      parquetSceltaOptions: [
        { value: "", label: "— nessuna —" },
        { value: "CERCHIO", label: "Cerchio" },
        { value: "QUADRATO", label: "Quadrato" },
        { value: "TRIANGOLO", label: "Triangolo" },
      ],
    };
  },
  computed: {
    categoryGroup() {
      return getCategoryGroup(this.category);
    },
    tileGroup() {
      // [sc-48951] Con l'unità di vendita: i campi devono essere quelli che
      // il preventivo pretenderà, e il preventivo segue l'unità.
      return tileGroupOf(
        this.category,
        this.form.subCategory,
        this.form.salesUnit
      );
    },
    salesUnitOptions() {
      return salesUnitsFor(this.$store?.state?.companyProfileUnits);
    },
    /* Campi per scatola che il blocco della categoria mostra già: servono a
       non ripeterli qui sotto. */
    boxFieldsFromCategory() {
      return boxFieldsFromCategory(this.category);
    },
    /* [sc-48538 / task 48562] Quello che manca: la lista arriva dalla stessa
       funzione che il controllo usa per dire cosa serve a confermare un
       preventivo, così la creazione offre esattamente ciò che verrà preteso.
       Guarda l'unità di vendita, non la categoria: un articolo a M2 in
       categoria «bagno» non vedeva né i mq né i pezzi per scatola. */
    extraBoxFields() {
      const needed = boxFieldsForItem({
        ...this.form,
        category: this.category,
      });
      return needed.filter((f) => !this.boxFieldsFromCategory.includes(f));
    },
    priceLabel() {
      return priceLabelFor(this.form.salesUnit);
    },
  },
};
</script>
